<template>
  <div :class="wrapperClass">
    <div
      v-if="kyc_brand"
      class="top"
      :class="{ 'dis_none': $route.path !== '/user/KYC' && $route.path !== '/user/edit' }"
    >
      個人情報
    </div>
    <ul
      class="kyc-tab-frame"
      :class="{ 'dis_none': kyc_brand || $route.path !== '/user/KYC' && $route.path !== '/user/edit' }"
    >
      <li
        class="tab-items verify-items "
        :class="{ 'active': $route.path === '/user/edit' }"
        @click="$router.push('/user/edit')"
      >
        個人情報
      </li>
      <li
        class="tab-items kyc-items"
        :class="{ 'active': $route.path === '/user/KYC' }"
        @click="$router.push('/user/KYC')"
      >
        KYC認証
      </li>
    </ul>
    <ul
      class="nav-tabs "
      :class="{ 'dis_none': $route.path === '/user/KYC'|| $route.path === '/user/edit'}"
    >
      <li :class="{ 'active': $route.path === '/user' }" @click="$router.push('/user')">
        <span>
          {{ $t("Bao.personal") }}
        </span>
      </li>
      <li :class="{ 'active': $route.path === '/user/bet' }" @click="$router.push('/user/bet')">
        <span>
          {{ $t("Bao.my_game_bet") }}
        </span>
      </li>
      <li :class="transactionClass" @click="$router.push('/user/transaction')">
        <span>
          {{ $t("Bao.transaction-index") }}
        </span>
      </li>
      <li
        :class="{ active: $route.path === '/user/bank' || $route.path === '/user/bank/create' }"
        @click="$router.push('/user/bank')"
      >
        <span>{{ $t("Bao.add_bank_card") }}</span>
      </li>
      <li
        :class="{ 'active': $route.path === '/user/letter' }"
        @click="$router.push('/user/letter')"
      >
        <span>
          {{ $t("Bao.announcement_letter") }}
        </span>
      </li>
      <li
        :class="{ 'active': $route.path.startsWith('/user/event/me') }"
        @click="$router.push('/user/event/me')"
      >
        <span>
          {{ $t("Bao.bonus_info") }}
        </span>
      </li>
      <li
        :class="{ 'active': $route.path.startsWith('/user/news') }"
        @click="$router.push('/user/news')"
      >
        <span>
          {{ $t("Bao.news") }}
        </span>
      </li>
      <li
        v-show="$store.getters.token && $store.state.user.memberInfo.member_type !== 3"
        :class="{ 'active': $route.path === '/user/friend' }"
        @click="$router.push('/user/friend')"
      >
        <span>
          {{ $t("Bao.promos") }}
        </span>
      </li>
    </ul>
    <router-view :class="{'my-kyc kyc-container': route.path === '/user/edit' || route.path === '/user/KYC'}" />
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  computed: {
    route() {
      return this.$route
    },
    kyc_brand() {
      return this.$store.state.brand.info.kyc_brand !== 'self'
    },
    wrapperClass() {
      if (this.route.path === '/user/edit' && this.kyc_brand) {
        return 'my-wrap-kyc'
      } else if (this.route.path !== '/user/edit') {
        return 'my-wrap'
      } else {
        return 'my-kyc-wrap'
      }
    },
    transactionClass() {
      return {
        'active': this.route.path === '/user/transaction' ||
                  this.route.path === '/user/bonus' ||
                  this.route.path === '/user/commission' ||
                  this.route.path === '/user/deposit-record' ||
                  this.route.path === '/user/withdrawal-record'
      }
    }
  },
  created() {
  }
}
</script>
